export const RoutePostImportJdaBaseline = "/import-jda-baseline";

export type PayloadPostImportJdaBaseline = FormData;

export interface PayloadFormPostImportJdaBaseline {
  jda_site_file: File;
  jda_shelf_file: File;
  article_master_file: File;
  category_id: string; // it can be only text in FormData
  batch_date: string; // it can be only text in FormData
}

export interface ResponsePostImportJdaBaseline {
  imported_count: number;
  skipped_empty_count: number;
  skipped_existing_count: number;
}
